import React from "react";
import "./OperatorPatientListNew2.css";
import NavbarNew from "../Navbar/NavbarNew";
import questionMark from "../Images/Vector.png";
import search from "../Images/Search.png";
import { FaArrowUp } from "react-icons/fa";
import PatientRow from "./PatientRow";
import AddIcon from "../Images/Add Icon.png";
import AddIconWhite from "../Images/Add Icon white.png";
import Pagination from "@mui/material/Pagination";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Stack from "@mui/material/Stack";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import InvitePatientModal from "./InvitePatientModal";
import Footer from "./Footer";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useIdleTimer from "../../useIdleTimer";
import API from "../../api";
// import Pagination from './Pagination';
import axios from "axios";
import cross from "../Images/cross.png";
import log from "../../logger";

const OperatorPatientListNew = () => {
  const [storedUserObject, setstoredUserObject] = useState({});

  const [role, setRole] = useState("");
  // const storedUserObjectString = sessionStorage.getItem("userObject")
  // const storedUserObject = JSON.parse(storedUserObjectString);
  const username = storedUserObject.first_name;
  const [isUserLoading, setIsUserLoading] = useState(true);

  const [patients, setPatients] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [selectedPatientDetails, setSelectedPatientDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isErrorOpen, setIsErrorOpen] = useState(false);
  const [error, setError] = useState({
    email: "",
    res: "",
    first_name: "",
    last_name: "",
  });

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [isClicked, setIsClicked] = useState(false);
  const project = sessionStorage.getItem("project");
  const navigate = useNavigate();
  const handleIdle = () => {
    window.location.href = "/";
  };
  useIdleTimer(handleIdle, 1.2e6);

  const getToken = () => {
    console.log("Fetching token for role:", role);
    const token =
      role === "Physician" || role === "MRI-Tech" || role === "Nurse"
        ? sessionStorage.getItem("operator_token")
        : sessionStorage.getItem("admin_token");

    return token;
  };
  const handleErrorClose = () => {
    setIsErrorOpen(false);
  };

  const fetchUserRole = async () => {
    try {
      const response = await axios.get("/common/api/get_user_role/", {
        withCredentials: true,
      });

      setRole(response.data.role);
    } catch (error) {
      log.error("Error fetching user role", {
        endpoint: "/common/api/get_user_role/",
        method: "GET",
        project: project,
        response_status: 401,
        role: role,
        error_message: "Error fetching user role",
        error_stack: error.response?.data || error.message,
      });
    }
  };

  const fetchUser = async () => {
    try {
      const response = await axios.get("/common/api/get_user/", {
        withCredentials: true,
      });
      setstoredUserObject(response.data.user_object);
    } catch (error) {
      log.error("Error fetching user", {
        endpoint: "/common/api/get_user/",
        method: "GET",
        project: project,
        response_status: 401,
        role: role,
        error_message: "Error fetching user",
        error_stack: error.response?.data || error.message,
      });
    } finally {
      setIsUserLoading(false);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      await fetchUserRole();
      await fetchUser();
    };
    fetchData();
  }, []);

  // const handleGetPatients = async () => {
  //   try {
  //     const token = getToken();

  //     if (!token) {
  //       navigate("/physicians");
  //     }

  //     const response = await axios.get("/operator/get_all_patients/", {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //         project: project,
  //       },
  //       params: {
  //         page: currentPage,
  //         page_size: pageSize,
  //         searchQuery: searchQuery.trim(),
  //       },
  //     });

  //     if (response.status === 200) {
  //       log.info("Patients Fetched Successfully", {
  //         endpoint: "/operator/get_all_patients/",
  //         method: "GET",
  //         project: project,
  //         response_status: 200,
  //         role: role,
  //       });
  //       setPatients(response.data.patients);
  //       setTotalPages(response.data.total_pages || 1);
  //     } else {
  //       log.error("Failed to fetch patients", {
  //         endpoint: "/operator/get_all_patients/",
  //         method: "GET",
  //         project: project,
  //         response_status: 500,
  //         role: role,
  //         error_message: "Failed to fetch patients",
  //       });
  //       if (!searchQuery.trim()) {
  //         setError({
  //           res: "Failed to fetch patients. Status: " + response.status,
  //         });
  //         setIsErrorOpen(true);
  //       }
  //     }
  //   } catch (error) {
  //     log.error("Failed to fetch patients", {
  //       endpoint: "/operator/get_all_patients/",
  //       method: "GET",
  //       project: project,
  //       response_status: 500,
  //       role: role,
  //       error_message: "Failed to fetch patients",
  //       error_stack: error.response?.data || error.message,
  //     });

  //     if (!searchQuery.trim()) {
  //       setError("Failed to fetch patients. Please try again.");
  //       setIsErrorOpen(true);
  //     }
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleGetPatients = async () => {
    try {
      const response = await API.get("/operator/get_all_patients/", {
        headers: {
          project: project,
        },
        params: {
          page: currentPage,
          page_size: pageSize,
          searchQuery: searchQuery.trim(),
        },
      });
      if (response.status === 200) {
        log.info("Patients Fetched Successfully", {
          endpoint: "/operator/get_all_patients/",
          method: "GET",
          project: project,
          response_status: 200,
          role: role,
        });
        setPatients(response.data.patients);
        setTotalPages(response.data.total_pages || 1);
      } else {
        log.error("Failed to fetch patients", {
          endpoint: "/operator/get_all_patients/",
          method: "GET",
          project: project,
          response_status: 500,
          role: role,
          error_message: "Failed to fetch patients",
        });
        if (!searchQuery.trim()) {
          setError({
            res: "Failed to fetch patients. Status: " + response.status,
          });
          setIsErrorOpen(true);
        }
      }
    } catch (error) {
      log.error("Failed to fetch patients", {
        endpoint: "/operator/get_all_patients/",
        method: "GET",
        project: project,
        response_status: 500,
        role: role,
        error_message: "Failed to fetch patients",
        error_stack: error.response?.data || error.message,
      });

      if (!searchQuery.trim()) {
        setError("Failed to fetch patients. Please try again.");
        setIsErrorOpen(true);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (role) {
      handleGetPatients();
    }
  }, [role, currentPage, pageSize, searchQuery]);

  const handleSearch = (value) => {
    setSearchQuery(value);
  };
  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handlePageSizeChange = (size) => {
    setPageSize(size);
    setCurrentPage(1);
  };
  // const handleLogout = async () => {
  //   await axios.post("/operator/logout/", {}, { withCredentials: true });
  //   localStorage.clear();
  //   sessionStorage.clear();
  // };

  const [icon, setIcon] = useState(AddIcon);
  const handleMouseEnter = () => {
    setIcon(AddIconWhite);
  };

  const handleMouseLeave = () => {
    setIcon(AddIcon);
  };

  const iconStyle = {
    width: "calc(1.5vh + 0.5vw)",
    height: "calc(1.5vh + 0.5vw)",
    marginLeft: "0.5vw",
    transition: "opacity 0.3s ease",
  };
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const handleRowClick = (patient) => {
    sessionStorage.setItem("Patient", JSON.stringify(patient));
    navigate("/profile", { state: { patient } });
  };
  return (
    <>
      {!isUserLoading && <NavbarNew username={username} />}
      <div className="main-content">
        <div className="patient-list-container-main">
          <div className="patient-list-title-container">
            <h2 className="title-patient-list">Patient List</h2>
            <div className="patient-list-tooltip-container">
              <img
                src={questionMark}
                alt="info-icon"
                className="patient-list-info-icon"
              />
              <span className="patient-list-tooltip-text">
                View the patient list here
              </span>
            </div>
          </div>

          <div className="patient-list-search-container">
            <img
              src={search}
              alt="search"
              className="patient-list-search-icon"
            />
            <input
              type="search"
              className="patient-list-search-input"
              placeholder="Search Patients..."
              value={searchQuery}
              onChange={(e) => handleSearch(e.target.value)}
              aria-label="Search Patients"
            />
          </div>

          <button
            className="add-patient-list-button-new"
            onClick={handleOpenModal}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            Add Patient
            <img
              src={icon}
              alt="AddIcon"
              className="add-icon"
              style={iconStyle}
            />
          </button>
        </div>

        {!isMobile && (
          <div className="patient-list-patient-table-container">
            {loading && (
              <div className="loading-spinner-overlay">
                <div className="bouncing-loader">
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
            )}
            <>
              <div className="patient-list-table-header">
                <div className="patient-list-header-cell">MRN Number</div>
                <div className="patient-list-header-cell">First Name</div>
                <div className="patient-list-header-cell">Last Name</div>
                <div className="patient-list-header-cell">Email Address</div>
                <div className="patient-list-header-cell">Indication</div>
              </div>
              <div className="patient-list-table-body">
                {patients.map((patient, index) => (
                  <PatientRow key={index} patient={patient} />
                ))}
              </div>
            </>
            <div className="pagination-container">
              <Stack spacing={2}>
                <Pagination
                  count={totalPages}
                  siblingCount={0}
                  boundaryCount={1}
                  page={currentPage}
                  onChange={(event, page) => handlePageChange(page)}
                  shape="rounded"
                  showFirstButton
                  showLastButton
                  sx={{
                    "& .MuiPaginationItem-root": {
                      color: "#666666",
                      fontSize: "1vw",
                      borderRadius: "8px",
                      border: "1px solid #CCCCCC",
                    },
                    "& .Mui-selected": {
                      backgroundColor: "#66A091 !important",
                      color: "#FFFFFF !important",
                      fontSize: "1vw",
                      border: "1px solid #66A091",
                    },

                    "& .MuiPaginationItem-root:hover": {
                      backgroundColor: "#66A091",
                      color: "#FFFFFF",
                    },
                    "& .MuiPaginationItem-ellipsis": {
                      color: "#666666",
                    },
                    "& .MuiPaginationItem-icon": {
                      color: "#004C40",
                    },
                  }}
                />
              </Stack>

              <Select
                value={pageSize}
                onChange={(e) => handlePageSizeChange(Number(e.target.value))}
                variant="outlined"
                size="small"
                inputProps={{
                  "aria-label": "Items per page",
                }}
                style={{ minWidth: 60 }}
                sx={{
                  minHeight: 3,
                  borderRadius: "10px",
                  backgroundColor: "#ffffff",
                  color: "#000000",

                  // Outline styles
                  ".MuiOutlinedInput-notchedOutline": {
                    borderColor: "#666666",
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#000000",
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#555555",
                  },

                  "& .MuiInputBase-root": {
                    fontSize: "var(--font-size-xl)",
                  },

                  ".MuiOutlinedInput-input": {
                    fontSize: "var(--font-size-xl)",
                  },

                  // This one is optional but also affects padding + font
                  ".MuiSelect-select": {
                    padding: "8px 10px",
                    fontSize: "var(--font-size-xl)",
                    color: "#666666",
                  },

                  ".MuiSelect-root": {
                    minHeight: "unset",
                  },
                }}
              >
                <MenuItem value={10}>10 per page</MenuItem>
                <MenuItem value={25}>25 per page</MenuItem>
                <MenuItem value={50}>50 per page</MenuItem>
              </Select>
            </div>
          </div>
        )}
        {isMobile && (
          <div className="user-list-cards-container">
            {patients.map((patient, index) => (
              <div
                key={index}
                className="user-card"
                // onClick={handleRowClick((patient = { patient }))}
              >
                <p>
                  <strong>Name:</strong> {patient.first_name}{" "}
                  {patient.last_name}
                </p>{" "}
                {/* First and Last Name on one line */}
                <p>
                  <strong>Email:</strong> {patient.email}
                </p>{" "}
                {/* Email on second line */}
                <p>
                  <strong>MRN number:</strong>
                  {patient.mrn_number}
                </p>{" "}
                <p className="indication">
                  <strong>Indication:</strong>
                  {patient.indication && Array.isArray(patient.indication)
                    ? patient.indication.join(", ")
                    : ""}
                </p>{" "}
              </div>
            ))}
            <div className="pagination-container">
              <Stack spacing={2}>
                <Pagination
                  count={totalPages}
                  siblingCount={0}
                  boundaryCount={1}
                  page={currentPage}
                  onChange={(event, page) => handlePageChange(page)}
                  shape="rounded"
                  showFirstButton
                  showLastButton
                  sx={{
                    "& .MuiPaginationItem-root": {
                      color: "#333333",
                      fontSize: "var(--font-size-l)",
                      borderRadius: "8px",
                      border: "1px solid #CCCCCC",
                    },
                    "& .Mui-selected": {
                      backgroundColor: "#66A091 !important",
                      color: "#FFFFFF !important",
                      fontSize: "var(--font-size-l)",
                      border: "1px solid #66A091",
                    },

                    "& .MuiPaginationItem-root:hover": {
                      backgroundColor: "#66A091",
                      color: "#FFFFFF",
                    },
                    "& .MuiPaginationItem-ellipsis": {
                      color: "#666666",
                    },
                    "& .MuiPaginationItem-icon": {
                      color: "#004C40",
                    },
                  }}
                />
              </Stack>

              <Select
                value={pageSize}
                onChange={(e) => handlePageSizeChange(Number(e.target.value))}
                variant="outlined"
                size="small"
                inputProps={{
                  "aria-label": "Items per page",
                }}
                style={{ minWidth: 60 }}
                sx={{
                  minHeight: 3,
                  borderRadius: "10px",
                  backgroundColor: "#ffffff",
                  color: "#000000",
                  ".MuiOutlinedInput-notchedOutline": {
                    borderColor: "#333333",
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#000000",
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#555555",
                  },
                  ".MuiSelect-select": {
                    padding: "8px 10px",
                    fontSize: "var(--font-size-l)",
                    color: "#000000",
                  },
                  ".MuiSelect-root": {
                    minHeight: "unset",
                  },
                }}
              >
                <MenuItem value={10}>10 per page</MenuItem>
                <MenuItem value={25}>25 per page</MenuItem>
                <MenuItem value={50}>50 per page</MenuItem>
              </Select>
            </div>
          </div>
        )}

        {/* Pagination Section */}

        {/* </div> */}
        <InvitePatientModal open={isModalOpen} onClose={handleCloseModal} />
      </div>
      {isErrorOpen && (
        <div className="error-modal-overlay">
          <div className="error-modal-content">
            <div className="error-modal-header">
              <img src={cross} alt="Error" className="cross-image" />
            </div>
            <h2>Oh Snap!</h2>
            <p>{error}</p>
            <button className="error-ok-button" onClick={handleErrorClose}>
              Ok
            </button>
          </div>
        </div>
      )}
      <Footer />
    </>
  );
};

export default OperatorPatientListNew;
